import React from 'react';
import iconLogo from '../assets/img/logo_bbva.svg';
import iconClose from '../assets/img/icon_close.svg';
import ModalInferior from '../components/ModalInferior';
import Salir from '../components/Salir';
import {useState} from 'react';
import '../css/components/Header.css';

const Header = (props) =>{

  const {mostrar, hideClose, perfilHeader} = props;
  const [modalSalir, setModalSalir] = useState(false);

  const titulos = {
    'PERSONAL': 'Abre tu cuenta',
    'EMPRENDEDOR': 'Abre tu Cuenta Emprendedor',
  };

  function mostrarSalir() {
    setModalSalir(!modalSalir);
  }

  function cerrarModal() {
    setModalSalir(!modalSalir);
  }

  return (
    <div>
      <div className="header-primary items-center gap-0 md:gap-5 text-font5 relative">
        <img src={iconLogo} alt='logoBbva' className='hidden md:block'/>
        <span className={`flex-grow md:font-bbvaBook font-bbvaMedium md:leading-normal leading-loose text-center md:text-right md:pl-0 ${hideClose ? 'pl-0' : 'md:pl-40px'}`}>
          {titulos[perfilHeader]}
        </span>
        {!hideClose && (
          <button className='close-button' onClick={mostrarSalir}>
            <img src={iconClose} alt='imagenClose' className='header-img-close'></img>
          </button>
      )}
      </div>
      {modalSalir && (
        <ModalInferior>
          <Salir 
            mostrar={mostrar}
            cerrarModal={cerrarModal}
          ></Salir>
        </ModalInferior>
      )}
    </div>
  );
}

export default Header;